import styled, { css } from 'styled-components';
import LoadingSpinner from '@carvana/loading-spinner';
import { ModalHeader, ModalCloseButton } from '@carvana/modal';
import { CarvanaButton } from '@carvana/purchase-styles';
import {
  cvBreakpoint1920,
  cvBreakpoint1024,
  cvBreakpoint1280,
  cvBreakpoint768
} from '@carvana/theme';

export const CloseButton = styled(ModalCloseButton)`
  transform: scale(1.25);
`;

export const Header = styled(ModalHeader)`
  font-size: 16px;
  text-transform: none;
`;

export const Content = css`
  background-color: white;
  min-height: 100px;
  z-index: 1301;

  @media (min-width: 350px) {
    max-width: 400px;
  }

  @media (min-width: 480px) {
    max-width: 400px;
  }

  @media (min-width: ${cvBreakpoint768}px) {
    max-width: 450px;
  }

  @media (min-width: ${cvBreakpoint1024}px) {
    max-width: 600px;
  }

  @media (min-width: ${cvBreakpoint1280}px) {
    max-width: 704px;
  }

  @media (min-width: ${cvBreakpoint1920}px) {
    max-width: 704px;
  }

  &.loading {
    overflow-y: visible;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 20px;
  position: relative;
`;

const transitionSpeed = '.25s';

export const ModalLoadingSpinner = styled(LoadingSpinner).attrs({
  isLarge: true
})`
  background-color: white;
  bottom: 0;
  opacity: 0;
  top: 0;
  transition: opacity ${transitionSpeed}, visibility ${transitionSpeed};
  visibility: hidden;
  &.show {
    opacity: 1;
    visibility: visible;
  }
`;

export const BoldText = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  border-bottom: 1px solid #d9dde9;
  text-align: left;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 18px;
  margin-top: 8px;
  padding-bottom: 5px;

  @media (min-width: 320px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 12px;
    padding-bottom: 10px;
  }

  @media (min-width: 480px) {
    font-size: 24px;
    line-height: 32px;
    margin-top: 24px;
    padding-bottom: 15px;
  }
`;

export const BoldTextSmall = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  text-align: left;
  font-size: 10px;
  line-height: 18px;
  margin-bottom: 8px;
  margin-top: 8px;

  @media (min-width: 320px) {
    font-size: 12px;
    line-height: 24px;
    margin-bottom: 8px;
    margin-top: 12px;
  }

  @media (min-width: 480px) {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 15px;
    margin-top: 24px;
  }
`;

export const IconWrapper = styled.img`
  height: 100%;
  display: block;
  margin-right: 20px;
  margin-top: 5px;
`;

export const CheckmarkIconWrapper = styled.img`
  height: 100%;
  display: block;
  margin-right: 20px;
  margin-left: 6px;
  margin-top: 5px;
`;

export const CarIconWrapper = styled.img`
  height: 100%;
  display: block;
  margin-right: 19px;
  margin-left: 10px;
  margin-top: 5px;
`;

export const IconAndTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  & > img {
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  padding: 0px 30px;
  max-width: 420px;
`;

export const BodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  max-width: 436px;
  text-align: left;
  font-size: 10px;
  line-height: 14px;

  @media (min-width: 320px) {
    font-size: 12px;
    line-height: 18px;
  }

  @media (min-width: 480px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CheckmarkBodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  max-width: 436px;
  text-align: left;
  margin-left: 5px;
  font-size: 10px;
  line-height: 14px;

  @media (min-width: 320px) {
    font-size: 12px;
    line-height: 18px;
  }

  @media (min-width: 480px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CarBodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  max-width: 436px;
  text-align: left;
  margin-left: 3px;
  font-size: 10px;
  line-height: 14px;

  @media (min-width: 320px) {
    font-size: 12px;
    line-height: 18px;
  }

  @media (min-width: 480px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ButtonWrapper = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;

  @media (min-width: 320px) {
    margin-top: 5px;
  }

  @media (min-width: 480px) {
    margin-top: 20px;
  }

  @media (min-width: ${cvBreakpoint768}px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const CancelButton = styled(CarvanaButton)`
  min-width: 400px;
`;
